module.exports = __webpack_public_path__ + "img/logo.e7c79534.png";